import React from 'react'
import FontFile from '../shared/font-file'


// .10 Monogram — refresh replacement for the old `heritage` slot
// The old `heritage` component is intentionally left untouched so historical
// orders keep reprinting in FHA Sign DeVinne.
const Word = (props) => {
  return <FontFile
    font={'monogram'}
    overlayFont={'monogram-back'}
    topOffset='0.15em'
    multiplier={1}
    {...props}
    borderColor={props.backCol}

    emojiOffset={-0.1}
    emojiMultiplier={1.1}
  />
}

export default Word
